import { normalizeTextForMatching } from '../utils/addressValidationSource';
import type { AlgoliaLocationData, PoboxIndexRecord } from './types';

const POBOX_PREFIX_REGEX = /^(po\s*box|p\.?\s*o\.?\s*box|mailbox|post\s+office\s+box|gpo)\b/i;

const normalizeWhitespace = (value?: string) =>
  String(value || '')
    .replace(/\s+/g, ' ')
    .trim();

const normalizePoboxValue = (value?: string) => normalizeTextForMatching(normalizeWhitespace(value));
export const isPoboxAddress = (value?: string) => POBOX_PREFIX_REGEX.test(normalizeWhitespace(value));
export const normalizePoboxRecord = (record: AlgoliaLocationData): PoboxIndexRecord => {
  return {
    Suburb: normalizeWhitespace(record.locality),
    State: normalizeWhitespace(record.state),
    Postcode: normalizeWhitespace(record.postcode),
    objectID: record.objectID,
  };
};

export const matchesPoboxRecord = (
  record: PoboxIndexRecord,
  { suburb, state, postcode }: { suburb?: string; state?: string; postcode?: string }
) => {
  const isSuburbMatch = suburb ? normalizePoboxValue(record.Suburb) === normalizePoboxValue(suburb) : true;
  const isStateMatch = state ? normalizePoboxValue(record.State) === normalizePoboxValue(state) : true;
  const isPostcodeMatch = postcode ? normalizePoboxValue(record.Postcode) === normalizePoboxValue(postcode) : true;

  return isSuburbMatch && isStateMatch && isPostcodeMatch;
};
